import axios from 'axios';
import { getOdrBaseUrl, getRoomApiUrl } from '../socket';
var CryptoJS = require("crypto-js");
// let baseUrl='http://192.168.2.61:6061/'
export const getAcsToken = async () => {
  const { tokenAzureLogin } = await getAcsLoginToken();
  const response = await axios.post(
    `${getRoomApiUrl()}/token`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${tokenAzureLogin}`,
      },
    },
  );

  return response?.data?.data;
};


export const getAcsLoginToken = async () => {
  try {
    // Fetch salt and uniqueKey https://odr_adm_uat.uneecopscloud.com/api/Home/Generatesalt
    const saltResponse = await axios.get(getOdrBaseUrl() + "api/Home/Generatesalt");
    console.log('-----saltResponse----', saltResponse)
    let enc = saltResponse?.data?.salt_enc;
    let uniqueKey = saltResponse?.data?.uniqueKey;

    // Fetch token using salt and uniqueKey
    const tokenResponse = await getTokenFromLoginApi(enc, uniqueKey);

    // Return the token
    return {
      tokenAzureLogin: tokenResponse.tokenAzureLogin
    };
  } catch (error) {
    console.error('Error in getAcsLoginToken:', error);
    throw error; // Rethrow the error so it can be caught by the caller
  }
};

const getTokenFromLoginApi = async (enc, uniqueKey) => {
  const url = getOdrBaseUrl() + "api/Home/login"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
  };
  const body = {
    "UserName": getEncryptedValue(),
    "Password": getEncryptedValueWithHash("utl@123", getDecryptedValue(enc)),
    "uniqueKey": uniqueKey // Get data from Generate Salt API
  };
  try {
    const response = await axios.post(url, body, { headers });
    let tokenAzureLogin = response?.data?.authToken;
    //console.log("tokenAzureLogin-: " + tokenAzureLogin);
    return {
      tokenAzureLogin: tokenAzureLogin
    };
  } catch (error) {
    console.error("Error making POST request:", error);
    throw error; // Rethrow the error so it can be caught by the caller
  }
};

const getEncryptedValue = () => {
  let key = "0123456789123456";
  var iv = getRandomString(16);
  let ciphertext = encrypt(iv, key, "odraiuser");
  let ciphertextConversion = (ciphertext + ":" + iv);
  let encyrptedValue = btoa(ciphertextConversion);
  return encyrptedValue;
}
const getEncryptedValueWithHash = (plaintext, salt) => {
  var hash = CryptoJS.SHA256(plaintext);
  hash = hash.toString(CryptoJS.enc.Hex);
  hash = hash + salt;
  hash = CryptoJS.SHA256(hash);
  hash = hash.toString(CryptoJS.enc.Hex);
  return hash;
}
const getDecryptedValue = (val) => {
  let key = "0123456789123456";
  let encryptedVal = atob(val);
  let decyrptedValue = decrypt(encryptedVal.split(':')[1], encryptedVal.split(':')[0], key);
  return decyrptedValue;
}
const getRandomString = () => {
  var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  for (var i = 0; i < 16; i++) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
  }
  return result;
}

const encrypt = (iv, passPhrase, plainText) => {
  var encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    CryptoJS.enc.Utf8.parse(passPhrase),
    { iv: CryptoJS.enc.Utf8.parse(iv), keySize: 128 / 8, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  return encrypted;
}

const decrypt = (iv, encText, key) => {
  var decrypt = CryptoJS.AES.decrypt(
    encText,
    CryptoJS.enc.Utf8.parse(key),
    { iv: CryptoJS.enc.Utf8.parse(iv), keySize: 128 / 8, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8);
  //console.log("decrypt: " + decrypt);
  return decrypt;
}

